import { Link } from "react-router-dom";
import { articles } from "./data";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import "../styling/style.css";

export default function BlogList() {
  return (
    <div className="section-container">
      <Nav />
      <section className="blog">
        <h1 className="blog-header">Blog</h1>
        <div className="blog-grid">
          {articles.map((article) => (
            <Link
              to={`/blog/${article.slug}`}
              key={article.id}
              className="blog-card"
            >
              <img
                src={article.image}
                alt={article.title}
                className="blog-card-image"
              />
              <h2 className="blog-card-title">{article.title}</h2>
              {/* <p className="blog-card-subtitle">{article.subtitle}</p> */}
            </Link>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
